import React, { useEffect, useState, useRef } from "react";
import DataTable from 'react-data-table-component';
import { fetchFailedInvoices } from "../../../helper/Api";
import { toast } from "react-toastify";
import { BiSolidEdit } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const FailedInvoices = ({setLoading, value}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [invoices, setInvoices] = useState([]);
    const customStyles = {
        headCells: {
        style: {
            fontWeight: "bold",
            fontSize: "14px"
        },
        },
    };
    const columns = [
        {
            name: 'Sanction Order No',
            selector: (row) => row.id,
            width: "100px"
        },
        {
            name: 'Voucher No',
            selector: (row) => row.voucher_no,
            width: "100px"
        },
        {
            name: 'Invoice No.',
            selector: (row) => row.invoice_no,
            width: "100px"
        },
        {
            name: 'Voucher Date',
            selector: (row) => row.voucher_date,
            sortable: true,
            width: "150px"
        },
        {
            name: 'Beneficiary Name',
            selector: (row) => row.company_name,
            sortable: true,
        },
        {
            name: 'Amount',
            selector: (row) => row.payable_amount,
            sortable: true,
            wrap: true
        },
        {
            name: 'Failed Reason',
            selector: (row) => row.reason,
            sortable: true,
            wrap: true
        },
        {
            name: 'Action',
            selector: (row) => <Link to={`/edit-failed-invoice/${row.id}`}><BiSolidEdit /></Link>,
            sortable: true,
            wrap: true
        },
        
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1);
    };
    const getFailedInvoices = async () => {
        try {
            setLoading(true);
            const res = await fetchFailedInvoices();
            if(res.data.status) {
                setLoading(false);
                setInvoices(res.data.result);
            }
        }catch(err) {
            setLoading(false);
            toast.error('Unable to fetch invoices', {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    }
    useEffect(() => {
        if(value === 0) {
            getFailedInvoices();
        }
    }, [value]);
    return (
        <DataTable
            customStyles={customStyles}
            className="dataTables_wrapper"
            columns={columns}
            data={invoices}
            fixedHeader
            fixedHeaderScrollHeight="600px"
            pagination
            paginationPerPage={rowsPerPage}
            paginationTotalRows={invoices.length}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            onChangeRowsPerPage={handleChangeRowsPerPage}
        />
    )
}

export default FailedInvoices;